export class MicInvComb {
  idMicroInversor: number;
  idProduto: number;
  descricao: string;
  regra: string;
  ativo: boolean;
}
